import React from 'react'
import styled from '@emotion/styled'
import GeneralModal from './GeneralModal'
import Button from '../../generic/button'
import { FlexRowDiv } from '../Basics'

export default ({ onClickPositive, onClickNegative, positiveCopyOverride, negativeCopyOverride, children, testId, ...props }) => (
  <GeneralModal testid={testId} {...props}>
    {children}
    <FlexRowDiv>
      {onClickPositive && <DoneButton data-testid={ `${testId}-btn-continue`} onClick={onClickPositive}>{positiveCopyOverride || 'Continue'}</DoneButton>}
      {onClickNegative && <DoneButton data-testid={ `${testId}-btn-cancel`} onClick={onClickNegative}>{negativeCopyOverride || 'Cancel'}</DoneButton>}
    </FlexRowDiv>
  </GeneralModal>
)

const DoneButton = styled(Button)`
  margin: 16px 8px 0px 8px;
`
